module.exports = __webpack_public_path__ + "static/media/icon-sort-arrow.52140143.svg";